import {
  Header as HeaderStyled,
  Content,
  HeaderBg,
  Headline,
  HeroDescription,
} from "./styles/Header.styled";
import React from "react";
import {
  H2,
  HighLightedText,
  Overlay,
  PrimaryButton,
  SecondaryButton,
  Flex,
} from "./styles/Utilities.styled";
import Resume from "./pdfs/Elton_Lucien_Resume.pdf";
import HeaderBackground from "./HeaderBackground";
import Nav from "./Nav";
import { FormattedMessage } from "react-intl";
import scrollToSection from "./helpers/scrollTo";
import messages from "./locales/messages";
import profile from "./config/profile";

const Header = ({ contactModalState, setLocale }) => {
  const [, setContactModalOpen] = contactModalState;
  const onContactButtonClick = () => setContactModalOpen(true);

  const { firstName, lastName, headline, description, email } = profile;

  return (
    <HeaderStyled>
      <HeaderBackground />
      <Overlay />
      <Flex
        align="center"
        justify="flex-end"
        $m="auto"
        style={{ minHeight: "7rem" }}
      >
        <Nav
          onContactButtonClick={onContactButtonClick}
          setLocale={setLocale}
        />
      </Flex>
      <Content>
        <Flex vertical>
          <H2>
            <HighLightedText>{firstName}</HighLightedText> {lastName}
          </H2>
          <Headline>
            <FormattedMessage {...headline} />
          </Headline>
          <HeroDescription>
            <FormattedMessage {...description} />
          </HeroDescription>
          <Flex gap="1.5rem" wrap $mt="1.5rem">
            <PrimaryButton
              href="#PROJECTS"
              onClick={(event) => scrollToSection(event, "PROJECTS")}
            >
              <FormattedMessage {...messages["hero.viewMyWork"]} />
            </PrimaryButton>
            <SecondaryButton href={`mailto:${email}`}>
              <FormattedMessage {...messages["hero.getInTouch"]} />
            </SecondaryButton>
            <SecondaryButton
              href={Resume}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              <FormattedMessage {...messages.resume} />
            </SecondaryButton>
          </Flex>
        </Flex>
        <HeaderBg />
      </Content>
    </HeaderStyled>
  );
};

export default Header;
